export const FETCH_MAIN_CALENDAR_EVENT_REQUEST = 'FETCH_MAIN_CALENDAR_EVENT_REQUEST';
export const FETCH_MAIN_CALENDAR_EVENT_SUCCESS = 'FETCH_MAIN_CALENDAR_EVENT_SUCCESS';
export const FETCH_MAIN_CALENDAR_EVENT_FAILURE = 'FETCH_MAIN_CALENDAR_EVENT_FAILURE';

export const FETCH_ALL_CALENDAR_EVENTS_REQUEST = 'FETCH_ALL_CALENDAR_EVENTS_REQUEST';
export const FETCH_ALL_CALENDAR_EVENTS_SUCCESS = 'FETCH_ALL_CALENDAR_EVENTS_SUCCESS';
export const FETCH_ALL_CALENDAR_EVENTS_FAILURE = 'FETCH_ALL_CALENDAR_EVENTS_FAILURE';

